//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {getProduce} from '@/api/news';
import Clipboard from 'clipboard';
export default {

  data() {
    return {
      code:'',
      url:''
    };
  },
  components: {

  },

  methods: {
    download(){
      var u = navigator.userAgent, app = navigator.appVersion;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isIOS){
        window.location.href="https://itunes.apple.com/cn/app/id1024460351";//https://itunes.apple.com/cn/app/id1024460351
      }else{
        window.location.href = "https://sj.qq.com/appdetail/io.dcloud.H55BDF6BE";
      }
    },
    getProduce(){
      var originalUrl = 'yp://app?type=recommendCode&code='+ this.code;
      let params = {linkUrl:originalUrl}
      getProduce(params).then((res) => {
        this.url = res.data;
      })
    },

  },
  mounted () {
    this.code = this.$route.query.code;
    this.getProduce();
    var btn = document.getElementById('btn');
    var clipboard = new Clipboard(btn);//实例化
    clipboard.on('success', (e)=> {//复制成功执行的回调，可选
      this.$dialog.toast({
        mes: '复制成功！',
        timeout: 1000,
        icon: 'success',
      });
    });
    clipboard.on('error', (e)=> {//复制失败执行的回调，可选
      this.$dialog.toast({
        mes: '复制失败！',
        timeout: 1000,
        icon: 'error',
      });
    });
  },
};





// WEBPACK FOOTER //
// ./src/pages/downLoad/index2.vue